import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { FaArrowLeft,FaArrowRight } from "react-icons/fa";

const VillaSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [villas, setVillas] = useState([]);
  const sliderRef = useRef(null);
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  // Fetch villas from Firestore
  useEffect(() => {
    const fetchVillas = async () => {
      try {
        const villasCollection = collection(db, 'villas');
        const villasSnapshot = await getDocs(villasCollection);
        const villasData = villasSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setVillas(villasData);
      } catch (error) {
        console.error('Error fetching villas:', error);
      }
    };

    fetchVillas();
  }, []);

  const handleScroll = (direction) => {
    const isMobile = window.innerWidth <= 768;
    const cardWidth = isMobile ? window.innerWidth - 30 : 590;
    const newIndex = direction === 'left'
      ? Math.max(currentIndex - 1, 0)
      : Math.min(currentIndex + 1, villas.length - 1);
    setCurrentIndex(newIndex);
    sliderRef.current.scrollTo({
      left: newIndex * cardWidth,
      behavior: 'smooth',
    });
  };

  // Touch event handlers for swiping
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!touchStartX.current || !touchEndX.current) return;
    const deltaX = touchStartX.current - touchEndX.current;
    const swipeThreshold = 50;
    if (Math.abs(deltaX) > swipeThreshold) {
      if (deltaX > 0) {
        handleScroll('right');
      } else {
        handleScroll('left');
      }
    }
    touchStartX.current = null;
    touchEndX.current = null;
  };

  return (
    <div className="villa-slider-container position-relative">
      <div className="header-row">
        <h2 className="villa-heading">Your Villa Stay Starts Here</h2>
        <div className="arrow-container">
          <button
            className={`arrow left-arrow ${currentIndex === 0 ? 'disabled' : ''}`}
            onClick={() => handleScroll('left')}
            aria-label="Previous villa"
          >
            <FaArrowLeft />
          </button>
          <button
            className={`arrow right-arrow ${currentIndex === villas.length - 1 ? 'disabled' : ''}`}
            onClick={() => handleScroll('right')}
            aria-label="Next villa"
          >
           <FaArrowRight />
          </button>
        </div>
      </div>
      <div
        className="villa-slider d-flex overflow-hidden"
        ref={sliderRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {villas.map((villa, index) => (
          <Link
            to={`/villa/${villa.title.toLowerCase().replace(/\s+/g, '-')}`}
            state={{ villa }}
            key={index}
            className="villa-card text-decoration-none"
          >
            <img src={villa.imageUrls[0 | undefined]} alt={villa.title} className="img-fluid" />
            <div className="villa-info p-2">
              <p className="location mb-1">{villa.location}</p>
              <h5 className="title-card mb-1">{villa.title}</h5>
              <p className="details mb-1">{villa.details}</p>
              <p className="description">{villa.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default VillaSlider;